import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiUsers, FiTrendingUp } from "react-icons/fi";
import { IoTrendingDown } from "react-icons/io5";
import { PiStickerDuotone } from "react-icons/pi";
import { TbTicket } from "react-icons/tb";
import { FaRegUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../assets/Css/Dashboard.css";
import Outlet from "../componment/Outlet";

const Dashboard = () => {
  const [hasNotification, setHasNotification] = useState(false);
  const [selectedRange, setSelectedRange] = useState("Last 6 Months");
  const [selectedTab, setSelectedTab] = useState("Users");

  // API data states
  const [totalUsers, setTotalUsers] = useState(0);
  const [newUsersLast7Days, setNewUsers] = useState(0);
  const [inactiveUsers, setTotalProducts] = useState(0);
  const [deletedUsers, setTotalBlockedUsers] = useState(0);
  const [users, setUsers] = useState([]);
  const [deletedUsersData, setDeletedUsersData] = useState([]);
  const [inactiveUsersData, setInactiveUsersData] = useState([]);


  const navigate = useNavigate();

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const getTotalCounts = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) return;

      const response = await axios.get(
        "https://network.rentel.in/admin/total-counts",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { totalUsers, newUsersLast7Days, inactiveUsers, deletedUsers } =
        response.data;

      setTotalUsers(totalUsers || 0);
      setNewUsers(newUsersLast7Days || 0);
      setTotalProducts(inactiveUsers || 0);
      setTotalBlockedUsers(deletedUsers || 0);

    } catch (error) {
      // console.log("Error fetching total counts:", error);
    }
  };

  const getDeletedUsers = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) return;
      const response = await axios.get(
        "https://network.rentel.in/admin/users?isDeleted=true",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Handle the response as needed
      const deletedUsersData = response.data.users || [];
      setDeletedUsersData(deletedUsersData);
    } catch (error) {
      // console.log("Error fetching deleted users:", error);
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };


  useEffect(() => {
    getTotalCounts();
    getDeletedUsers();
  }, []);


  const [openPopup, setOpenPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleView = (user) => {
    setSelectedUser(user);
    setOpenPopup(true);
  };

  const handleClose = () => {
    setOpenPopup(false);
    setSelectedUser(null);
  };

  const handleUndelete = async () => {
    if (!selectedUser) return;

    try {
      const token = localStorage.getItem("adminToken");
      if (!token) throw new Error("No admin token");

      const response = await axios.patch(
        `https://network.rentel.in/admin/users/${selectedUser._id}`,
        { isDeleted: false },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const updatedUser = response.data;

      // Remove user from deletedUsersData
      setDeletedUsersData((prev) =>
        prev.filter((u) => u._id !== selectedUser._id)
      );

      // console.log("User undeleted:", updatedUser);

      setOpenPopup(false);
      setSelectedUser(null);
    } catch (error) {
      // console.error("Undelete error:", error.response || error);
      alert("Failed to undelete user. Try again!");
    }
  };

  // Unblock user
  const handleUnblock = async (id, block) => {
    try {
      const token = localStorage.getItem("adminToken");

      await axios.patch(
        `https://network.rentel.in/admin/users/${id}`,
        {
          isActive: !block,
          seen: true,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setInactiveUsersData((prev) =>
        prev.map((user) =>
          user._id === id ? { ...user, isActive: !block, seen: true } : user
        )
      );

      setOpenPopup(false);
      setSelectedUser(null);
    } catch (err) {
      // console.log("Error unblocking user:", err);
    }
  };


  // GET Inactive Users
  const getInactiveUsers = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) return;

      const response = await axios.get(
        "https://network.rentel.in/admin/users?isActive=false",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setInactiveUsersData(response.data.users || []);
    } catch (error) {
      // console.log("Error fetching inactive users:", error);
    }
  };


  // Single useEffect only
  useEffect(() => {
    getTotalCounts();
    getDeletedUsers();
    getInactiveUsers();
  }, []);


  const getNewUsers = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      if (!token) return;

      const response = await axios.get(
        "https://network.rentel.in/admin/users",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const allUsers = response.data.users || [];

      // Sort karvu (latest first)
      const sorted = [...allUsers].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setUsers(sorted);
    } catch (error) {
      // console.log("Error fetching users:", error);
    }
  };
  useEffect(() => {
    getTotalCounts();
    getDeletedUsers();
    getInactiveUsers();
    getNewUsers();   // <-- ADD THIS
  }, []);

  // 1️⃣ Filter function (must be above)
  const filterLastWeekUsers = (users) => {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    return users.filter((u) => {
      const created = new Date(u.createdAt);
      return created >= lastWeek && created <= today;
    });
  };

  // ------------------ 2️⃣ USE FILTER FUNCTION ------------------
  const newUsersData = filterLastWeekUsers(users);

  // Sort newest first
  const sortedNewUsers = [...newUsersData].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );



  return (
    <Outlet>
      <div className="dashboard-header">
        <h2 className="dashboard-title">Dashboard</h2>
      </div>

      <div className="total-list">
        {/* Card 1 */}
        <div className="user-card" onClick={() => handleSelectedTab("Users")}>
          <div className="gap-uppu">
            <div className="user-header">
              <div className="user-icon-bg">
                <FiUsers className="user-icon" />
              </div>
              <div className="user-data">
                <span className="label">Total Users</span>
                <p className="count">{totalUsers}</p>
              </div>
            </div>
            <div className="user-footer">
              <div className="growth">
                <FiTrendingUp className="trend-icon" />
                <span className="percentage">3.56%</span>
              </div>
              <span className="note">from last week</span>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="user-card" onClick={() => handleSelectedTab("NewUsers")}>
          <div className="gap-uppu">
            <div className="user-header">
              <div className="user-icon-bg">
                <FaRegUser className="user-icon" />
              </div>
              <div className="user-data">
                <span className="label">New Users</span>
                <p className="count">{newUsersLast7Days}</p>
              </div>
            </div>
            <div className="user-footer">
              <div className="growth">
                <FiTrendingUp className="trend-icon" />
                <span className="percentage">3.56%</span>
              </div>
              <span className="note">from last week</span>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="user-carda" onClick={() => handleSelectedTab("InactiveUsers")}>
          <div className="gap-uppua">
            <div className="user-headera">
              <div className="user-icon-bga">
                <PiStickerDuotone className="user-iconi" />
              </div>
              <div className="user-datae">
                <span className="labela">Total Block User</span>
                <p className="counta">{inactiveUsers}</p>
              </div>
            </div>
            <div className="user-footers">
              <div className="growth-downs">
                <IoTrendingDown className="trend-icona" />
                <span className="percentages">1.06%</span>
              </div>
              <span className="notea">from last week</span>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="user-card" onClick={() => handleSelectedTab("DeletedUsers")} style={{ cursor: "pointer" }}>
          <div className="gap-uppu">
            <div className="user-header">
              <div className="user-icon-bg">
                <TbTicket className="user-icon" />
              </div>
              <div className="user-data">
                <span className="label">Total Delete User</span>
                <p className="count">{deletedUsers}</p>
              </div>
            </div>
            <div className="user-footer">
              <div className="growth">
                <FiTrendingUp className="trend-icon" />
                <span className="percentage">5.70%</span>
              </div>
              <span className="note">from last week</span>
            </div>
          </div>
        </div>
      </div>
      {selectedTab === "Users" && (<div></div>)}
      {/* 2 */}
      {selectedTab === "NewUsers" && (
        <div className="deleted-container">
          <h2 className="title">New Users Table View</h2>

          <div className="table-wrapper">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>User</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Created Date</th>
                </tr>
              </thead>

              <tbody>
                {sortedNewUsers.map((user) => (
                  <tr key={user._id}>
                    <td>{user._id}</td>

                    <td>
                      <div className="user-box">
                        <div className="avatar">{user.name?.charAt(0)}</div>
                        <span>{user.name}</span>
                      </div>
                    </td>

                    <td>{"+91 " + user.phoneNumber}</td>
                    <td>{user.email}</td>

                    <td>
                      {user.createdAt
                        ? new Date(user.createdAt).toLocaleDateString("en-GB")
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>


            </table>
          </div>
        </div>
      )}


      {/* 3 */}
      {selectedTab === "InactiveUsers" && (
        <div className="deleted-container">
          <h2 className="title">Inactive User Table View</h2>

          <div className="table-wrapper">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>User</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Blocked Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {inactiveUsersData.map((user) => (
                  <tr className="nano" key={user.id || user._id}>
                    <td>{user._id}</td>

                    <td>
                      <div className="user-box">
                        <div className="avatar">{user.name.charAt(0)}</div>
                        <span>{user.name}</span>
                      </div>
                    </td>

                    <td>{"+91 " + user.phoneNumber}</td>
                    <td>{user.email}</td>
                    <td className="status blocked">Blocked</td>
                    <td>{formatDate(user.updatedAt)}</td>

                    <td>
                      <button className="view-btn" onClick={() => handleView(user)}>
                        View
                      </button>
                    </td>

                    {openPopup && (
                      <div className="popup-overlay">
                        <div className="popup-box">
                          <h3 className="popup-title">User Details</h3>

                          <p><strong>ID:</strong> {selectedUser?._id}</p>
                          <p><strong>Name:</strong> {selectedUser?.name}</p>
                          <p><strong>Email:</strong> {selectedUser?.email}</p>
                          <p><strong>Phone:</strong> {selectedUser?.phoneNumber}</p>

                          <div className="popup-actions">
                            <button
                              className="undelete-btn"
                              onClick={() => handleUnblock(user._id, false)}
                            >
                              Unblock
                            </button>


                            <button className="close-btn" onClick={handleClose}>
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* 4 */}
      {selectedTab === "DeletedUsers" && (
        <div className="deleted-container">
          <h2 className="title">Deleted User Table View</h2>

          <div className="table-wrapper">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>User</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Deleted Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {deletedUsersData.map((user) => (
                  <tr className="nano" key={user.id || user._id}>
                    <td>{user._id}</td>

                    <td>
                      <div className="user-box">
                        <div className="avatar">{user.name.charAt(0)}</div>
                        <span>{user.name}</span>
                      </div>
                    </td>

                    <td>{"+91 " + user.phoneNumber}</td>
                    <td>{user.email}</td>
                    <td className="status deleted">Deleted</td>
                    <td>{formatDate(user.updatedAt)}</td>


                    <td>
                      <button className="view-btn" onClick={() => handleView(user)}>
                        View
                      </button>
                    </td>

                    {openPopup && (
                      <div className="popup-overlay">
                        <div className="popup-box">
                          <h3 className="popup-title">User Details</h3>
                          <p><strong>ID:</strong> {selectedUser ? (selectedUser.id || selectedUser._id) : ""}</p>
                          <p><strong>Name:</strong> {selectedUser?.name}</p>
                          <p><strong>Email:</strong> {selectedUser?.email}</p>
                          <p><strong>Phone:</strong> {selectedUser?.phoneNumber}</p>

                          <div className="popup-actions">
                            <button className="undelete-btn" onClick={handleUndelete}>
                              Undelete
                            </button>

                            <button className="close-btn" onClick={handleClose}>
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

    </Outlet>
  );
};

export default Dashboard;
